import React from "react";

import ScheduleSlider from "../components/Schedule/ScheduleSlider";
import Standings from "../components/Season/Standings";
import VideoBlock from "../components/Video/VideoHomeBlock";
import NewsBlock from "../components/News/NewsLine";
import RegistrationWidget from "../components/RegistrationWidget/RegistrationWidget";
import HomeSEO from "../components/SEO/HomeSEO";
import { VisuallyHiddenHeading } from "../components/Common/PageHeading";
// import BannerBlock from "../components/Banners/BannerBlock";

export const HomePageWrap = () => {
  return (
    <>
      <HomeSEO />
      {/* The page has no visible title line; the logo carries the brand. */}
      <VisuallyHiddenHeading>Slick Racing Ukraine — формульна ліга симрейсингу</VisuallyHiddenHeading>
      {/* <BannerBlock /> */}
      <RegistrationWidget />
      <NewsBlock />
      <ScheduleSlider />

      <Standings />

      <VideoBlock />
    </>
  );
};
